export default function isContext(obj) {
  return obj && obj.name && obj.loc;
}
